const calculateBoxPieceFromQty = (qty, packingsize)=>{
	let bQty = parseInt(packingsize) > 0 ? Math.floor(parseInt(qty)/parseInt(packingsize)) : 0;
	let pQty = parseInt(packingsize) > 0 ? parseInt(qty)%parseInt(packingsize) : 0;	

	return {
		box: bQty,
		piece: pQty
	};
}
export default calculateBoxPieceFromQty